/* eslint-disable local-rules/no-dynamic-classname */
import { memo } from "react";
import PropTypes from "prop-types";
import "./CreditCardPictos.scss";

const CreditCardPictos = ({ creditCardCodes }) => {
	return (
		<div className="credit-card-pictos">
			{creditCardCodes.map(code => (
				<i
					key={code}
					className={`icon icon--${code.toLowerCase()}-colorful credit-card-pictos__icon`}
					data-testid={code}
				/>
			))}
		</div>
	);
};

CreditCardPictos.defaultProps = {
	creditCardCodes: [],
};

CreditCardPictos.propTypes = {
	creditCardCodes: PropTypes.array,
};

export default memo(CreditCardPictos);
